import React from 'react';
import { Link } from 'gatsby';
import Menu from './Menu';
import Hamburger from './Hamburger';
import logo from '../images/logo.svg';
import logoMobile from '../images/logo.svg';
import Alert from 'react-bootstrap/Alert';
import MenuMobile from './MenuMobile';
import Sticky from 'react-sticky-el';
// import * as Scroll from 'react-scroll';
import { Link as ScrollLink, Events } from 'react-scroll';
import { globalHistory as history } from '@reach/router';
import { PATHS } from '../utils/urls';


// let focusElement = document.getElementById("name");
// console.log("Focus Element = " + focusElement)

//announcement bar
function AlertDismissible(props) {

	const { location } = history;


	const [show, setShow] = React.useState(true);

	const sourcePage = "/blog/company-updates/g2-spring-2021-charthop-mid-market-leader/";

	if (location.pathname === sourcePage) {
	} else {
		if (show) {
			return (
				<Alert variant="secondary" onClose={() => setShow(false)} dismissible className="bg-secondary">
					<div className="container">
						
					<Link to={sourcePage}><p className="text-white text-md-center font-weight-bold"> 
                        <span role="img" aria-label="party"> 🎉</span> G2 names ChartHop a leader for the Mid-Market in Spring Report.<u> Learn more about why all employees love ChartHop.</u>  <span role="img" aria-label="party">🎉</span></p></Link> 



					</div>
				</Alert>
			);
		}
	}
	return '';
}

class Header extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			menuActive: false,
			focusTarget: false
		};
	}


	componentDidMount = () => {
		this.setState({ focusTarget: document.querySelector(".longFormParentContainer .focusInputElement") })
		// console.log("Query selector: " + document.querySelector(".longFormParentContainer .focusInputElement"))
		Events.scrollEvent.register('end', function (to, element) {
			if (element.id === 'request-demo') {
				var inputFocus = document.querySelector(".longFormParentContainer .focusInputElement");
				inputFocus.focus();
			}
			Events.scrollEvent.remove('end');
		});

		var demoLink = document.querySelector("#demo-link")
		// console.log("Demo link: " + demoLink)

		demoLink.onClick = function () {
			console.log("clicked");
		}


		}
		toggleMenu = menuActive => {
			this.setState(prevState => ({
				menuActive: !prevState.menuActive,
			}));
		};
		focusFirstName() {
			document.querySelector(".longFormParentContainer .focusInputElement").focus();
			document.querySelector(".longFormParentContainer .focusInputElement").select();
		}

		toggleMenuClose() {
			const menuToggle = document.querySelector("#main-menu-mobile");
			const menuIcon = document.querySelector("#toggle-main-menu-mobile");

			// console.log(menuIcon);
			menuToggle.classList.remove("open");
			menuIcon.classList.remove("is-active");
			// handleClick = event => event.target.classList.add('click-state');
		}
	


		render() {
			let { focusTarget } = this.state;
			const RequestDemo = () => {
				
				if (!focusTarget) {
					return <Link to="/#request-demo" id="demo-link" className="button primary demo-link smoothScrollLink"><span className="d-none d-sm-inline " id="demo-a">GET LIVE DEMO</span></Link>

				} else {
					return <ScrollLink onClick={this.toggleMenuClose} to="request-demo" smooth={true} offset={-70} duration={2500} id="demo-link" className="button primary demo-link smoothScrollLink"><span className="d-none d-sm-inline " id="demo-a">GET LIVE DEMO </span></ScrollLink>
				}
			}
			return (

				<div className="header" id="headerNavigation">

					<div className="blogBanner">
						<AlertDismissible />
					</div>

					<Sticky className="sticky-wrapper">
						<div className="container">
							<div className="headerNavigation" >
								<div className="logo">
									<Link to={ PATHS.HOME }>
										<img alt="ChartHop Homepage" src={logo} />
									</Link>
								</div>
								<div className="logo-mobile">
									<Link to={PATHS.HOME}>
										<img alt="ChartHop Homepage" className="mt-1 mb-1" src={logoMobile} />
									</Link>
								</div>

								<MenuMobile active={this.state.menuActive} />
								<Menu />
								<div className="header-cta">

									{RequestDemo()}
									<a href="https://app.charthop.com/" className="button secondary" rel="noopener noreferrer">SIGN IN</a>
									<Hamburger toggleMenu={this.toggleMenu} />
								</div>

							</div>

						</div>
					</Sticky>
					{/* <div className="pb-md-4"></div> */}
				</div>
			);
		}
	}
	export default Header;
